var _excluded = ["children", "borderRadius", "rippleColor", "disabled", "width", "size", "rippleSize", "rippleMultiplier", "onSelectRippleColor", "shadowType", "isActive", "elevated", "delegateAnimationToChild"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useSpring, animated, to } from '@react-spring/web';
import { useDrag } from 'react-use-gesture';
import { useTheme } from '../../../ThemeProvider';
import StyledContainer from './styles';
import { usePrevious } from '../../utils';
var initialScale = 1;
var scaleDown = 0.97;
var defaultRippleSize = 40;
var yMovementThreshold = 20;

var InteractWrapper = function InteractWrapper(_ref, ref) {
  var children = _ref.children,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? '100px' : _ref$borderRadius,
      _ref$rippleColor = _ref.rippleColor,
      rippleColor = _ref$rippleColor === void 0 ? 'hsla(0, 0%, 0%, 0.5)' : _ref$rippleColor,
      disabled = _ref.disabled,
      width = _ref.width,
      size = _ref.size,
      _ref$rippleSize = _ref.rippleSize,
      rippleSize = _ref$rippleSize === void 0 ? defaultRippleSize : _ref$rippleSize,
      _ref$rippleMultiplier = _ref.rippleMultiplier,
      rippleMultiplier = _ref$rippleMultiplier === void 0 ? 1.5 : _ref$rippleMultiplier,
      onSelectRippleColor = _ref.onSelectRippleColor,
      shadowType = _ref.shadowType,
      isActive = _ref.isActive,
      elevated = _ref.elevated,
      delegateAnimationToChild = _ref.delegateAnimationToChild,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      springs = _useTheme.springs;

  var hasSecondRipple = Boolean(onSelectRippleColor);
  var containerSizeRef = React.useRef({
    left: 0,
    width: 0,
    height: 0,
    getBoundingClientRect: function getBoundingClientRect() {}
  });
  var containerRef = React.useRef(null);

  var _useSpring = useSpring(function () {
    return {
      scale: initialScale,
      config: springs.springBounceLight
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      scale = _useSpring2[0].scale,
      api = _useSpring2[1];

  var _useSpring3 = useSpring(function () {
    return {
      rippleOpacity: 0,
      secondaryRippleOpacity: 0,
      rippleScale: 1,
      secondaryRippleScale: 1,
      rippleLeft: 0,
      config: springs.springBounceFast
    };
  }),
      _useSpring4 = _slicedToArray(_useSpring3, 2),
      _useSpring4$ = _useSpring4[0],
      rippleScale = _useSpring4$.rippleScale,
      rippleLeft = _useSpring4$.rippleLeft,
      rippleOpacity = _useSpring4$.rippleOpacity,
      secondaryRippleOpacity = _useSpring4$.secondaryRippleOpacity,
      secondaryRippleScale = _useSpring4$.secondaryRippleScale,
      setRippleApi = _useSpring4[1];

  var isTouch = React.useRef(false);
  var previousIsActive = usePrevious(isActive); // for radio buttons that are no longer selected

  React.useEffect(function () {
    if (!isActive && previousIsActive) {
      setRippleApi.start({
        secondaryRippleOpacity: 0,
        immediate: false
      });
    }
  }, [previousIsActive, isActive, setRippleApi]); // this can be called from react-use-gesture or by a child in response to a keypress

  var _finishRippleAnimation = function finishRippleAnimation(calledByChild) {
    setContainerSize();
    var userWasHoldingDownItem = scale.get() !== 1;

    if (!userWasHoldingDownItem) {
      setRippleApi.start(_objectSpread({
        rippleOpacity: 1,
        secondaryRippleOpacity: isActive ? 1 : 0,
        immediate: true
      }, calledByChild ? {
        rippleScale: 1.3,
        secondaryRippleScale: 1.3
      } : {}));
    } // make sure this animation kicks off on the next tick,
    // after the above rippleOpacity change has been applied,
    // by putting it inside a setTimeout


    var rippleScale = containerSizeRef.current.width / rippleSize * rippleMultiplier;
    setTimeout(function () {
      setRippleApi.start({
        rippleScale: rippleScale,
        secondaryRippleScale: rippleScale,
        rippleOpacity: 0,
        secondaryRippleOpacity: isActive ? 0 : 1,
        immediate: false
      });
    });
  };

  React.useImperativeHandle(ref, function () {
    return {
      finishRippleAnimation: function finishRippleAnimation() {
        _finishRippleAnimation(true);
      }
    };
  });

  var setContainerSize = function setContainerSize() {
    var boundingRect = containerRef.current.getBoundingClientRect();
    containerSizeRef.current = boundingRect;
  };

  var bind = useDrag(function (_ref2) {
    var first = _ref2.first,
        last = _ref2.last,
        event = _ref2.event,
        _ref2$xy = _slicedToArray(_ref2.xy, 2),
        x = _ref2$xy[0],
        y = _ref2$xy[1],
        touches = _ref2.touches,
        _ref2$memo = _ref2.memo,
        memo = _ref2$memo === void 0 ? {} : _ref2$memo;

    // prevent double triggering of polyfilled mouse events on touch interfaces
    // the next release of react-use-gesture should make this unnecessary
    if (touches > 0 && isTouch.current === false) isTouch.current = true;
    if (touches === 0 && !last && isTouch.current === true) return;

    var handleTouchCancelled = function handleTouchCancelled() {
      if (memo.click) return;
      api.start({
        scale: initialScale
      });
      setRippleApi.start({
        rippleOpacity: 0,
        immediate: false
      });
    };

    if (last || isTouch.current && y >= yMovementThreshold) {
      handleTouchCancelled();
    }

    function tapEnd(e) {
      var target = e.currentTarget;
      target.removeEventListener('click', tapEnd);
      if (memo.timeout) clearTimeout(memo.timeout);
      memo.click = true;
      api.start({
        scale: initialScale
      });
      if (!delegateAnimationToChild) _finishRippleAnimation();
    }

    function tapBegin() {
      setContainerSize();
      var target = event.currentTarget;
      target.addEventListener('click', tapEnd);
      memo.click = false;
      var rippleScale = containerSizeRef.current.height / defaultRippleSize * 3;
      var width = containerSizeRef.current.width;
      var secondaryRippleScale = width / rippleSize * rippleMultiplier; // set ripple to its initial position

      setRippleApi.start({
        rippleScale: 1,
        secondaryRippleScale: isActive ? secondaryRippleScale : 1,
        rippleOpacity: 0,
        secondaryRippleOpacity: isActive ? 1 : 0,
        rippleLeft: x - containerSizeRef.current.left,
        immediate: true
      }); // this can be interrupted if the user clicks (immediately releases the tap)

      var delay = 20;
      memo.timeout = setTimeout(function () {
        delete memo.timeout;
        api.start({
          scale: scaleDown
        });
        setRippleApi.start({
          immediate: false,
          rippleOpacity: 1,
          rippleScale: rippleScale,
          secondaryRippleScale: isActive ? secondaryRippleScale : rippleScale
        });
      }, delay);
    }

    if (first) tapBegin();else {
      var normalizedX = Math.min(Math.max(0, x - containerSizeRef.current.left), containerSizeRef.current.width);
      setRippleApi.start({
        rippleLeft: normalizedX,
        immediate: true
      });
    }
    return memo;
  }, {
    enabled: !disabled
  });
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({}, bind(), {
    style: {
      transform: scale.to(function (scale) {
        return "scale(".concat(scale, ")");
      })
    },
    $borderRadius: borderRadius,
    $rippleColor: rippleColor,
    $rippleSize: rippleSize,
    $shadowType: shadowType,
    width: width,
    size: size,
    ref: containerRef
  }, rest), children, /*#__PURE__*/React.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/React.createElement(animated.div, {
    className: "ripple",
    "aria-hidden": true,
    style: {
      transform: to([rippleScale, rippleLeft], function (scale, left) {
        return "translate(".concat(left - rippleSize / 2, "px, -50%) scale(").concat(scale, ")");
      }),
      opacity: rippleOpacity,
      zIndex: isActive ? 1 : 0
    }
  }), hasSecondRipple && /*#__PURE__*/React.createElement(animated.div, {
    className: "ripple",
    "aria-hidden": true,
    style: {
      transform: to([secondaryRippleScale, rippleLeft], function (secondaryRippleScale, left) {
        return "translate(".concat(left - rippleSize / 2, "px, -50%) scale(").concat(secondaryRippleScale, ")");
      }),
      backgroundColor: colors[onSelectRippleColor] || onSelectRippleColor,
      opacity: secondaryRippleOpacity
    }
  })), elevated && /*#__PURE__*/React.createElement(animated.div, {
    className: "ersatz-shadow",
    style: {
      opacity: scale.to(function (scale) {
        return (scale - scaleDown) / (initialScale - scaleDown);
      })
    }
  }));
};

export default /*#__PURE__*/React.forwardRef(InteractWrapper);